




















































































































































import firebase from "firebase";
//import {auth, functions,firestore } from "@/scripts/firebase";
import { Component, Mixins, Watch  } from "vue-property-decorator";
import ModalEventDetails from "@/components/ModalEventDetails.vue";
import ModalAlert from "@/components/ModalAlert.vue";
import Common from '../../mixins/common';
import FullCalendar, {CalendarOptions, EventClickArg, DatesSetArg} from '@fullcalendar/vue'
//import FullCalendar, { CalendarApi, CalendarOptions, EventApi, DateSelectArg, EventClickArg, EventSourceInput, EventSource, DatesSetArg, EventChangeArg, EventInput } from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
//import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
//import interactionPlugin, {Draggable, DateClickArg, DropArg, EventDropArg } from '@fullcalendar/interaction'
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import moment from 'moment-timezone'
import jaLocale from '@fullcalendar/core/locales/ja';
import { EventDocData, EventData, EventExtendedProps } from "@/scripts/datatypes";//eslint-disable-next-line
const jaconv = require("jaconv")

type Taxonomy = {
	[key in 'class' | 'group'|'type'|'status'|'postStatus']: Term[]
};

interface Term {
  name: string;
  id: string;
  count: number;
}

interface SelectedFilter {
  class: Term | null;
  group: Term | null;
  type: Term | null;
  status: Term | null;
  postStatus: Term | null;
  searchText: string;
}

@Component({
  components: {
    FullCalendar,
    ModalEventDetails,
    ModalAlert
  }
})

export default class Schedule extends Mixins(Common) {
  eventsObservers: firebase.Unsubscribe[] = []

  taxonomy: Taxonomy = {
    class: [],
    group: [],
    type: [],
    status: [],
    postStatus: [],
  }

  selectedFilter: SelectedFilter = {
    class: null,
    group: null,
    type: null,
    status: null,
    postStatus: null,
    searchText: '' 
  }
  
  showModalEventDetails = false
  showModalAlert = false

  alert = {title: '', message: ''}


  defaultTimeZone = moment.tz.guess()
  timeZone = this.defaultTimeZone
  defaultTheEventData: EventData = {
    id: '',
    title: '',
    timeZone: this.timeZone,
    start: moment().startOf('hour').toDate(),
    end: moment().add(1,'hours').startOf('hour').toDate(),
    extendedProps: {
      note: '',
      type: 'lesson',
      className: '',
      classId: '',
      //classRef: undefined,
      teacherUids: [],
      studentUids: [],
      groupName: '',
      groupId: '',
      //groupRef: undefined,
      hostUids: [],
      guestUids: [],
      memberUids: [],
      memberMeta: {},
      status: 'pending',
      postStatus: 'draft',
      author: '',
      schoolId: this.$store.getters.schoolId,
      updateTime: undefined,
      creationTime: undefined
    }
  }

  theEventData = {...this.defaultTheEventData}

  modalProps = {
    isLoading: false,
    errorMessage: '',
    theEventData: this.theEventData
  }

  rawEvents: EventData[] = []
  currentEvents: EventData[] = []

  theDatesSet = {} as DatesSetArg

  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin,listPlugin ,momentTimezonePlugin ],
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,listMonth'
    },
    navLinks: true,
    selectable: true,
    initialView: 'listMonth',
    locales: [jaLocale],
    timeZone: this.timeZone,
    locale: this.lang,
    eventClick: this.handleEventClick,
    eventTimeFormat: { hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: undefined },//timeZoneName: 'short'
    eventStartEditable: false,
    eventDurationEditable: false,
    datesSet: this.handleCalendarDatesSet,
  }

  Loading = false

  Timer: number | undefined

  get offset(){
    return moment().tz(this.timeZone).format('Z')
  }

  setEvents(){
    const api = this.theDatesSet.view.calendar
    api.batchRendering(() => {
      api.removeAllEvents()
      this.currentEvents.forEach((event) => {
        api.addEvent(event)
      })
    })
  }

  @Watch('Loading')
  changeLoading(newval: boolean){
    if(newval === false && this.rawEvents.length > 0){
      this.setTaxonomies()
      this.setFilterOnEventsData(this.selectedFilter)
      this.setEvents()
    }
  }

  get updatedRawEvents(){
    if(this.currentEvents.length !== this.rawEvents.length){
      return true
    }
    
    if(this.currentEvents.some((cEvent,index) => {
        return this.rawEvents.some((rEvent) => {return cEvent.id === rEvent.id && cEvent.extendedProps.updateTime !== rEvent.extendedProps.updateTime})
       })){
      return true
    }

    if(this.currentEvents.some((cEvent,index) => {
        return this.rawEvents.every((rEvent) => {return cEvent.id !== rEvent.id})
       })){
      return true
    }

    return false
  }

  @Watch('updatedRawEvents',{immediate: true})
  changeUpdateRawEvents(updated: boolean, prev: boolean){
    if(updated === false){
      return
    }
    this.Loading = true
    const delay = 400
    window.clearTimeout(this.Timer)
    this.Timer = window.setTimeout(() => {
      this.Loading = false
    }, delay)
  }

  handleCalendarDatesSet(arg: DatesSetArg){
    this.theDatesSet = arg
    const startDate = moment(arg.view.activeStart).toDate()
    const endDate = moment(arg.view.activeEnd).toDate()

    this.rawEvents = []
    this.setTaxonomies()
    this.$unsubscriber(this.eventsObservers)

    const eventDocToEventObject = (doc: firebase.firestore.QueryDocumentSnapshot) => {
      const row = doc.data() as EventDocData

      const extendedProps = {...row}
      
      Object.keys(extendedProps).forEach((prop) => {
        if(['start','end','title'].includes(prop)){
          delete extendedProps[prop as keyof EventExtendedProps]
        }
      })

      return {
        id: doc.id,
        title: row.title || '',
        start: row.start || undefined,
        end: row.end || undefined,
        timeZone: this.timeZone,
        editable: true,
        display: 'auto',
        extendedProps: extendedProps,
      }
    }

    const setEventData = (doc: firebase.firestore.QueryDocumentSnapshot) => {
      const findIndex = this.rawEvents.findIndex(event => {return event.id === doc.id})
      const event = eventDocToEventObject(doc)
      if(findIndex === -1){
        this.rawEvents.push(event)
      }else{
        this.rawEvents.splice(findIndex, 1, event)
      }
    }

    try{
      const eventsStartQuery = this.$getUserEventsColRef().orderBy('start','asc').startAt(startDate).endBefore(endDate)

      const observerStart = eventsStartQuery.onSnapshot((snapshot) => {
        //snapshot.docChanges
        snapshot.docs.forEach((doc) => {
          setEventData(doc)
        })
      }) as firebase.Unsubscribe

      this.eventsObservers.push(observerStart)

      const eventsEndQuery = this.$getUserEventsColRef().orderBy('end','asc').startAfter(startDate).endAt(endDate)

      const observerEnd = eventsEndQuery.onSnapshot((snapshot) => {
        snapshot.docs.forEach((doc) => {setEventData(doc)})
      }) as firebase.Unsubscribe

      this.eventsObservers.push(observerEnd)

    }catch(error){
      console.log(error)
    }
    
  }

  setFilterOnEventsData(filter: SelectedFilter){
    const searchText = jaconv.toHiragana(jaconv.toZen(filter.searchText)) as string

    const settingFilter = !! (filter.class || filter.group || filter.type || filter.status || filter.postStatus || filter.searchText)

    const foundSearchText = (val: string, event: EventData) => {
      if(val === ''){
          return false
      }

      const memberMeta = event.extendedProps.memberMeta

      if(Object.values(memberMeta).some((user)=>{return this.$findTextByUserProfile(val,user)})){
        return true
      }

      let targetText = event.title + event.note

      targetText = jaconv.toHiragana(jaconv.toZen(targetText))

      if(targetText.indexOf(val) > -1){
          return true
      }
      return false
    }

    this.currentEvents = this.rawEvents.map(event => {
      const groupId = event.extendedProps.groupId
      const groupName = event.extendedProps.groupName
      const classId = event.extendedProps.classId
      const className = event.extendedProps.className
      const type = event.extendedProps.type
      const status = event.extendedProps.status
      const postStatus = event.extendedProps.postStatus

      event.display = 'auto'

      if(! settingFilter){
        return event
      }

      if(searchText && ! foundSearchText(searchText, event)){
        event.display = 'none'
        return event
      }

      if(filter.type && filter.type.name && filter.type.name !== type){
        event.display = 'none'
        return event
      }

      if(filter.status && filter.status.name && filter.status.name !== status){
        event.display = 'none'
        return event
      }

      if(filter.postStatus && filter.postStatus.name && filter.postStatus.name !== postStatus){
        event.display = 'none'
        return event
      }

      if(filter.group && filter.group.name && filter.group.name !== groupName){
        event.display = 'none'
        return event
      }

      if(filter.class && filter.class.name && filter.class.name !== className){
        event.display = 'none'
        return event
      }

      return event
    })
  }

  @Watch('selectedFilter',{deep: true})
  changeSelectedFilter(newVal: SelectedFilter){
    this.setFilterOnEventsData(newVal)
    this.setEvents()
  }

  setTaxonomies(){
    this.resetCountTaxonomy()
  
    this.rawEvents.forEach(event => {
      const classId = event.extendedProps.classId
      const className = event.extendedProps.className
      const groupId = event.extendedProps.groupId
      const groupName = event.extendedProps.groupName
      const status = event.extendedProps.status
      const type = event.extendedProps.type
      const postStatus = event.extendedProps.postStatus
      
      if(groupId && groupName){
        this.setTaxonomy(this.taxonomy.group ,groupName, groupId)
      }

      if(classId && className){
        this.setTaxonomy(this.taxonomy.class ,className, classId)
      }

      if(type){
        this.setTaxonomy(this.taxonomy.type,type)
      }

      if(status){
        this.setTaxonomy(this.taxonomy.status,status)
      }

      if(postStatus){
        this.setTaxonomy(this.taxonomy.postStatus,postStatus)
      }
    })
  }

  resetCountTaxonomy(){
    Object.keys(this.taxonomy).forEach((type) => {
      const t = type as keyof Taxonomy
      this.taxonomy[t] = this.taxonomy[t].map((term) => {
        term.count = 0
        return term
      })
    })
  }

  setTaxonomy(type: Term[], name: string, id = ''){
    if(! name){
      return
    }

    const findIndex = type.findIndex((term) => {
      if(id !== ''){
        return term.id === id && term.name === name
      }
      return term.name === name
    })

    const term: Term = {
      name: name,
      count: 1,
      id: id
    }

    if(findIndex === -1){
      type.push(term)
    }else{
      term.count = 1 + type[findIndex].count
      type.splice(findIndex, 1,term)
    }
  }

  handleEventClick(arg: EventClickArg): void {
    if(arg.jsEvent.ctrlKey === true && arg.view.type.indexOf('list') === -1){//selected
      this.currentEvents = this.currentEvents.map((event) => {
        if(event.id === arg.event.id){
          event.borderColor = event.borderColor ? '' : '#000'
          event.groupId = event.groupId ? '' : 'selected'
          arg.view.calendar.batchRendering(() => {
            arg.event.remove()
            arg.view.calendar.addEvent(event)
          })
        }
        return event
      })
    }else{
      this.theEventData.id = arg.event.id
      this.theEventData.title = arg.event.title
      this.theEventData.timeZone = this.timeZone
      this.theEventData.start = arg.event.start || this.theEventData.start
      this.theEventData.end = arg.event.end || this.theEventData.end
      this.theEventData.extendedProps = arg.event.extendedProps as EventExtendedProps
      this.showModalEventDetails = true
    }
  }

  @Watch('timeZone')
  changeTimezone(newVal: string){
    this.calendarOptions.timeZone = newVal
    this.$set(this.theEventData,'timeZone' , newVal)
  }

  get timeZoneNames(){
    const timezone = moment.tz.names().map((name: string) => {
      return {name: name, zone: moment.tz(name).format('Z')}
    })

    timezone.unshift({name: this.defaultTimeZone, zone: moment.tz(this.defaultTimeZone).format('Z')})

    return timezone
  }

  get lang(): string {
    return this.$store.getters.lang
  }

  @Watch('lang')
  changeLang(newVal: string){
    this.calendarOptions.locale = newVal
    //this.showModalEditEvent = false
  }



  created(){
    console.trace('created')
  }

  mounted(){
   //
  }

  destroyed() {
    this.$unsubscriber(this.eventsObservers)
  }
}
